<template>
  <div>
    <div class="slider-title">
      Ärende {{ item.projectCode }}
      <div class="close-panel" @click="$emit('closePanel')"><i class="fal fa-times close-icon"></i></div>
    </div>

    <div class="content slider-modal">
      <ul class="context-icons ">
        <li v-if="hasRole('Staff')" @click="openCustomerModal"><i class="fal fa-building"></i><span>Kund</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
// import CustomerModal from '@/components/modals/CustomerModal'

import { mapGetters } from 'vuex'

export default {
  name: 'context-menu-modal',
  data () {
    return {
    }
  },

  props: {
    item: Object
  },

  computed: {
    ...mapGetters('auth', ['hasPermission', 'hasRole'])
  },

  methods: {
    openCustomerModal () {
      alert('openCustomerModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/ContextMenuModal.vue